import React, { Component } from 'react';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import {
  Button,
  Form,
  Grid,
  Header,
  Input,
  Message,
  Segment
} from 'semantic-ui-react';

import '../css/Login.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import navigationManager, { VIEW_SELECTION } from '../managers/NavigationManager';

import DynamicSatelliteService from '../services/DynamicSatelliteService';

import { setDocumentTitle } from '../utils/setDocumentTitle';

import { register } from '../i18n';

const t = register('ForgotPassword');

export default @inject(
  'dynamicSatelliteManager', 'userManager')
@observer
class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      fail: false,
      invalidEmail: false,
      loaded: false,
      success: false
    };

    this.messageRef = React.createRef();

    this.Logo = SatCoreComponent('Logo');
    this.SatCoreLoader = SatCoreComponent('SatCoreLoader');
  }

  async componentDidMount() {
    this.setState({ loaded: false });

    const { dynamicSatelliteManager } = this.props;

    navigationManager.setView(VIEW_SELECTION.LOGIN);

    if (dynamicSatelliteManager.isDynamicSatellite && !Auth.publisherSatelliteCode) {
      await DynamicSatelliteService.fetchDynamicSatelliteByDomain();
      setTimeout(() => {
        this.setState({ loaded: true });
        setDocumentTitle('resetPassword', { translationObjName: 'ForgotPassword' });
      }, 500);
    } else {
      this.setState({ loaded: true });
      setDocumentTitle('resetPassword', { translationObjName: 'ForgotPassword' });
    }
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState(
      {
        [e.target.name]: e.target.value
      }
    );
  }

  handleSendEmail = async (event) => {
    const { email } = this.state;
    const { userManager } = this.props;
    event.preventDefault();
    this.setState({ fail: false, success: false });

    if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
      this.setState({ invalidEmail: true }, () => {
        this.messageRef?.current?.focus?.();
      });
      return;
    }

    const result = await userManager.sendResetEmail(email);
    if (result) {
      this.setState({ fail: false, success: true }, () => {
        this.messageRef?.current?.focus?.();
      });
    } else {
      this.setState({ fail: true, success: false }, () => {
        this.messageRef?.current?.focus?.();
      });
    }
  }

  resetState = () => {
    this.setState({
      fail: false,
      invalidEmail: false,
      success: false
    });
  }

  render() {
    if (Auth.loggedIn()) {
      return <Redirect to='/' />;
    }
    const { Logo, SatCoreLoader } = this;
    const { fail, invalidEmail, loaded, success } = this.state;
    const shouldDisplayAccessibleMessageParent = fail || invalidEmail || success;

    return loaded ? (
      <Grid
        className='fullHeight login-body forgot-password-body'
        role='main'
        textAlign='center'
        verticalAlign='middle'>
        <Grid.Column>
          <h1 className='sr-only page-heading'>{t('resetPassword')}</h1>
          <Form>
            <Header
              aria-label={t('resetPassword')}
              as='h2'
              attached='top'
              block
              className='forgot-password-form-header'>
              <Logo />
              <div className='header-text'>
                {t('resetPassword')}
              </div>
            </Header>
            <div className='login-divider' />
            <Segment attached className='element-body-login element-body-login-forgot-password'>
              <Form.Field className='form-field-default form-field-email' required>
                <label htmlFor='email'>Email</label>
                <Input
                  aria-describedby='email-error'
                  aria-invalid={invalidEmail}
                  aria-required='true'
                  id='email'
                  name='email'
                  onChange={this.handleChange}
                  onFocus={this.resetState}
                  placeholder='name@email.com'
                  required
                  type='email' />
              </Form.Field>
              <Form.Field className='form-field-default form-field-actions'>
                <Button className='reset' onClick={this.handleSendEmail} primary>
                  Send Reset Email
                </Button>
              </Form.Field>
            </Segment>
          </Form>
          <div
            ref={this.messageRef}
            aria-live='assertive'
            className={classNames('accessible-message-parent', {
              'accessible-negative-message-parent': !success,
              'accessible-positive-message-parent': success
            })}
            style={{
              display: shouldDisplayAccessibleMessageParent ? 'block' : 'none'
            }}
            tabIndex={-1}>
            {(success)
              ? (
                <div role='alert'>
                  <Message positive>
                    <Message.Header>Check your email</Message.Header>
                    <p>
                      If a profile is associated with that email, you will receive a link to reset your password.
                    </p>
                  </Message>
                </div>
              ) : null}
            {(fail) ? (
              <div role='alert'>
                <Message negative>
                  <Message.Header>Something went wrong</Message.Header>
                  <p>
                    Resetting your password has failed.  Please check your email and try again.
                  </p>
                </Message>
              </div>
            ) : null}
            {(invalidEmail) ? (
              <div id='email-error' role='alert'>
                <Message negative>
                  <Message.Header>Something went wrong</Message.Header>
                  <p>
                    Please enter a valid email format. (name@example.com)
                  </p>
                </Message>
              </div>
            ) : null}
          </div>
        </Grid.Column>
      </Grid>
    ) : <SatCoreLoader />;
  }
}

SatCoreRegister('ForgotPassword', ForgotPassword);
